import { AdhocFilter, IFilterRule } from '@cxstudio/reports/entities/adhoc-filter.class';

export class DriversTarget {
	filters: AdhocFilter;
}